import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Crown, Download } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CONTACT_EMAIL, REGULATION_PATH, SITE_DOMAIN } from "@/content/siteContent";

export default function LegalPageLayout({ kicker, title, intro, summaryCards, sections, ctaLabel = "Torna al ticket", pdfDownloadUrl }) {
  return (
    <div className="status-page-shell page-noise legal-page-shell">
      <div className="legal-page-inner">
        <header className="legal-page-header">
          <Link to="/" className="brand-lockup" data-testid="legal-page-home-link">
            <span className="brand-mark" aria-hidden="true">
              <Crown className="h-4 w-4" />
            </span>
            <div>
              <span className="wordmark">Fanta Royal</span>
              <p className="brand-tagline">Conquista la corona</p>
            </div>
          </Link>

          <div className="legal-header-actions">
            <Button asChild variant="outline" className="secondary-cta">
              <Link to="/#ticket" data-testid="legal-page-ticket-link">
                {ctaLabel}
              </Link>
            </Button>
          </div>
        </header>

        <Card className="luxury-card legal-hero-card" data-testid="legal-page-hero-card">
          <CardContent className="p-6 sm:p-8">
            <div className="legal-topline">
              <span className="section-kicker">{kicker}</span>
              <span className="legal-domain-badge">{SITE_DOMAIN}</span>
            </div>
            <h1 className="section-title legal-page-title">{title}</h1>
            <p className="section-description legal-page-intro">{intro}</p>

            {pdfDownloadUrl && (
              <div className="legal-pdf-download-section">
                <Button asChild variant="outline" className="secondary-cta pdf-download-button">
                  <a href={pdfDownloadUrl} download target="_blank" rel="noopener noreferrer" data-testid="pdf-download-button">
                    <Download className="mr-2 h-4 w-4" />
                    Scarica PDF regolamento completo
                  </a>
                </Button>
              </div>
            )}

            <div className="legal-summary-grid">
              {summaryCards.map((card, index) => (
                <div key={card.title} className="legal-summary-card" data-testid={`legal-summary-card-${index + 1}`}>
                  <h2>{card.title}</h2>
                  <p>{card.text}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        <div className="legal-content-grid">
          {sections.map((section, index) => (
            <Card key={section.title} className="luxury-card legal-section-card" data-testid={`legal-section-${index + 1}`}>
              <CardContent className="p-6 sm:p-8">
                <h2 className="legal-section-title">{section.title}</h2>
                {section.paragraphs?.map((paragraph) => (
                  <p key={paragraph} className="legal-section-copy">
                    {paragraph}
                  </p>
                ))}
                {section.bullets?.length ? (
                  <ul className="legal-list">
                    {section.bullets.map((bullet) => (
                      <li key={bullet}>{bullet}</li>
                    ))}
                  </ul>
                ) : null}
              </CardContent>
            </Card>
          ))}
        </div>

        <Card className="luxury-card legal-footer-card">
          <CardContent className="p-6 sm:p-8">
            <div className="legal-footer-grid">
              <div>
                <p className="footer-title">Contatti ufficiali</p>
                <div className="footer-links">
                  <a href={`mailto:${CONTACT_EMAIL}`} className="footer-link" data-testid="legal-contact-email-link">
                    {CONTACT_EMAIL}
                  </a>
                  <Link to={REGULATION_PATH} className="footer-link" data-testid="legal-footer-regulation-link">
                    Regolamento
                  </Link>
                </div>
              </div>
              <div>
                <Button asChild className="primary-cta">
                  <Link to="/#ticket" data-testid="legal-footer-ticket-cta">
                    <ArrowLeft className="mr-2 h-4 w-4" />
                    Torna al checkout ticket
                  </Link>
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
